export default {"src":"/_next/static/media/human-grade.b4045057.svg","height":71,"width":69,"blurWidth":0,"blurHeight":0};